export default __webpack_public_path__ + "static/legal-transcription-popup-banner-469049f7a8e2741a82364d040325ec0c.png";